import React, { forwardRef } from "react";
import MaskedInput from "react-text-mask";

const CreditCardInput = forwardRef(function CreditCardInput(props, setRef) {
  return (
    <MaskedInput
      {...props}
      ref={(innerRef) => {
        // react-text-mask envuelve el <input> en un objeto → usamos inputElement
        if (innerRef && innerRef.inputElement) {
          setRef(innerRef.inputElement);
        }
      }}
      mask={(rawValue = "") => {
        rawValue.replace(/\s/g, "");

        let mask = [
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          " ",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          " ",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          " ",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ];

        if (rawValue.length === 14)
          mask = [
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ];

        if (rawValue.length === 15)
          mask = [
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ];

        return mask;
      }}
      placeholderChar={"\u2000"}
    />
  );
});

export default CreditCardInput;
